import { render, staticRenderFns } from "./table_page.vue?vue&type=template&id=32530db1&scoped=true"
import script from "./table_page.vue?vue&type=script&lang=js"
export * from "./table_page.vue?vue&type=script&lang=js"
import style0 from "./table_page.vue?vue&type=style&index=0&id=32530db1&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32530db1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32530db1')) {
      api.createRecord('32530db1', component.options)
    } else {
      api.reload('32530db1', component.options)
    }
    module.hot.accept("./table_page.vue?vue&type=template&id=32530db1&scoped=true", function () {
      api.rerender('32530db1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/table_page/table_page.vue"
export default component.exports